import { Instagram, Twitter, TrendingUp } from "lucide-react";

export const DISCORD_URL = "https://discord.gg/dTvUsb6Gdn";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/gd89jjhf_image.png";
export const HIPPO_URL = "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/0xe6524g_image.png";

export const tabs = [
  { id: "telegram", label: "Telegram" },
  { id: "mentorship", label: "Mentorship" },
  { id: "youtube", label: "YouTube" },
  { id: "social", label: "Réseaux Sociaux" },
  { id: "propfirm", label: "PropFirm" },
  { id: "broker", label: "Broker" }
];

// Testimonials screenshots URLs
export const testimonialImages = [
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/yw0quqfs_547884924_17886908259358797_7374947515252510138_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/1nwkvwh4_473627196_17951579762913372_2415474585338922244_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/xx8tcxq7_483876404_17958240974913372_3931341457708198675_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/zqspws2b_485584107_17959498610913372_1454058029329347875_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/uxqwkicp_504083426_17967859073913372_3392287053139181678_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/r5w6w9vj_561894560_18045164105678820_4194292068488453798_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/gfbf5m9c_485950743_17959498565913372_8107939768975987904_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/ebztp1kx_490746211_17962130873913372_6723516798664706605_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/tfgrj31h_504178678_17967858914913372_349127046493771134_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/hxn0btu5_511356124_17969939369913372_3296088725339379814_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/ijs3xph1_504277760_17967858884913372_7173917946960006943_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/ndvm8i4n_526284704_17974086932913372_4217287827533832503_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/hkwe2l7r_527161912_17974087097913372_4580909544951528553_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/g9d7z2xm_527124365_17974087163913372_6924252944396423168_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/bgdaprxg_525625960_17974087184913372_5193630870594284196_n.jpg"
];

// Trade results screenshots URLs
export const tradeImages = [
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/f0p79sh5_573001932_17984609336913372_2341979096000110974_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/keja8y8h_623212440_17994409085913372_2145842387986112100_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/6yc3ov0c_621743586_17993953688913372_6795541280587846897_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/a67tolpw_616321070_17993061071913372_6923103245551936527_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/3lj8iqfw_607193556_17990825135913372_6253525642794622955_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/98eukdcp_574022913_17985439448913372_6850349910337321957_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/0h8br9zh_605602881_17990513045913372_3692112837275770203_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/rbxug191_583079534_17986285538913372_6190681068770242853_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/l1gaxmno_568504670_17983890521913372_8521431358459419726_n.jpg",
  "https://customer-assets.emergentagent.com/job_protrader-hub-1/artifacts/qlgh3oy8_561997106_17982510860913372_2092677512314513202_n.jpg"
];

export const socialLinks = [
  {
    name: "Instagram",
    url: "https://instagram.com/700s_ict",
    icon: Instagram,
    color: "hover:text-pink-400"
  },
  {
    name: "X",
    url: "https://x.com/700S_ICT",
    icon: Twitter,
    color: "hover:text-sky-400"
  },
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@700s_ict",
    icon: TrendingUp,
    color: "hover:text-cyan-400"
  }
];
